import { Grid, IconButton, Stack, Typography } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { useState } from 'react';
import { SectionHeader } from './SectionHeader';
import { EditClinicalComment } from './EditClinicalComment';

export function ClinicianComment({ test }) {
  const [neurologicalExamination, setNeurologicalExamination] = useState(test?.neurologicalExamination);
  const [editMode, setEditMode] = useState(false);

  const handleSave = (neurogicalExamination) => {
    setNeurologicalExamination(neurogicalExamination);
    setEditMode(false);
  };

  return (
    <>
      <Grid item xs={12}>
        <Stack direction="row">
          <SectionHeader name="Clinical comment" />
          {!editMode ? (
            <IconButton
              onClick={() => {
                setEditMode(true);
              }}
            >
              <EditIcon />
            </IconButton>
          ) : (
            ''
          )}
        </Stack>
      </Grid>
      <Grid item xs={12}>
        {!editMode ? <Typography>{neurologicalExamination?.clinicianComment}</Typography> : <EditClinicalComment neurologicalExamination={neurologicalExamination} testId={test?.uuid} onCancel={() => setEditMode(false)} onSaved={handleSave} />}
      </Grid>
    </>
  );
}
